export const TABLE_WRAPPER_CLASSNAME =
    "-mx-5 overflow-hidden rounded-none border-y border-x-0 border-surface-555 md:mx-0 md:rounded-md md:border-x [.p-dialog_&]:mx-0 [.p-dialog_&]:rounded-md [.p-dialog_&]:border-x";

export const CARD_TABLE_WRAPPER_CLASSNAME =
    "mx-0 md:rounded-none md:border-x-0";

export const PAGINATOR_JUSTIFY_CLASSNAME =
    "flex-nowrap justify-center md:flex-wrap md:justify-end";

export const PAGINATOR_PAGES_CLASSNAME =
    "whitespace-nowrap md:whitespace-normal";
